export const logout = (history) => {
    
  sessionStorage.removeItem("ACCESS_TOKEN");
  history.replace("/");
};
